import React, { useState, useEffect, useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Link, useLocation, useRouteMatch } from 'react-router-dom'

import navigation from '../../../menu-items'
import patientNavigation from '../../../patient-menu-items'
import { BASE_TITLE, BASENAME } from '../../../config/constant'
import { ConfigContext } from 'contexts/ConfigContext'
import PerspectiveBreadCrumb from './Perpspective'

const Breadcrumb = () => {
  let location = useLocation()
  let patientRouteMatch = useRouteMatch('/patient/:module/:submodule/:hn')
  const [main, setMain] = useState([])
  const [item, setItem] = useState([])
  const [subItem, setSubItem] = useState([])
  //navigation = patientRouteMatch?patientNavigation:navigation

  useEffect(() => {
    navigation.items.map((item, index) => {
      if (item.type && item.type === 'group') {
        getCollapse(item, index)
      }
      return false
    })
  })

  const getCollapse = (item) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse)
        } else if (collapse.type && collapse.type === 'item') {
          if (document.location.hash === '#' + BASENAME + collapse.url) {
            setMain(item)
            setItem(collapse)
          }
          if (collapse.children && collapse.children.length > 0) {
            setSubItem(collapse.children[0])
          }
        }
        return false
      })
    }
  }

  const onScrollToView = (id) => {
    document.getElementById(id).scrollIntoView()
  }

  let mainContent, itemContent, subItemContent
  let breadcrumbContent = ''
  let title = ''

  if (main && main.type === 'collapse') {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to={main.url ? main.url : '#'}>{main.title}</Link>
      </ListGroup.Item>
    )
  } else if (main && main.type === 'group') {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <span
          onClick={(e) => {
            onScrollToView(main.id)
          }}
        >
          {main.title}
        </span>
      </ListGroup.Item>
    )
  }

  if (item && item.type === 'item' && !item.breadcrumbs) {
    title = item.title
    let navIcons = false
    if (item.icon) {
      navIcons = (
        <span className="breadcrumb-pcoded-micon">
          <i className={item.icon}>{item.iconText ? item.iconText : ''}</i>
        </span>
      )
    }
    itemContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to={item.url ? item.url : '#'}>
          {navIcons} {title}
        </Link>
      </ListGroup.Item>
    )

    if (subItem && subItem.type === 'item' && !subItem.breadcrumbs) {
      title = subItem.title
      let navIcons = false
      if (subItem.icon) {
        navIcons = (
          <span className="breadcrumb-pcoded-micon">
            <i className={subItem.icon}>
              {subItem.iconText ? subItem.iconText : ''}
            </i>
          </span>
        )
      }
      subItemContent = (
        <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
          {navIcons} {title}
        </ListGroup.Item>
      )
    }

    if (item.breadcrumbs !== false) {
      breadcrumbContent = (
        <div className="page-header-">
          <div className="page-block-">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
                  <ListGroup.Item
                    as="li"
                    bsPrefix=" "
                    className="breadcrumb-item"
                  >
                    <Link to="/">
                      <i className="feather icon-home" />
                    </Link>
                  </ListGroup.Item>
                  {mainContent}
                  {itemContent}
                  {subItemContent}
                </ListGroup>
              </div>
            </div>
          </div>
        </div>
      )
    }

    //document.title = title + BASE_TITLE
  }

  if (item && item.type === 'item' && item.breadcrumbs === 'main') {
    title = item.title
    let navIcons = false
    if (item.icon) {
      navIcons = (
        <span className="breadcrumb-pcoded-micon">
          <i className={item.icon}>{item.iconText ? item.iconText : ''}</i>
        </span>
      )
    }
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to={item.url ? item.url : '#'}>
          {navIcons} {title}
        </Link>
      </ListGroup.Item>
    )

    if (location.pathname !== item.url) {
      itemContent = (
        <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
          {item.subBreadcrumbs}
        </ListGroup.Item>
      )
    } else {
      itemContent = ''
    }

    if (item.breadcrumbs !== false) {
      breadcrumbContent = (
        <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
          <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
            <Link to="/">
              <i className="feather icon-home" />
            </Link>
          </ListGroup.Item>
          {mainContent}
          {itemContent}
        </ListGroup>
      )
    }

    //document.title = title + BASE_TITLE
  }

  const configContext = useContext(ConfigContext)
  const { perspective } = configContext.state

  if (perspective) {
    breadcrumbContent = <PerspectiveBreadCrumb />
  }

  return <React.Fragment>{breadcrumbContent}</React.Fragment>
}

export default Breadcrumb
